import { Button, Typography } from '@mui/material';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';
import { useDashboardTFunction } from '@retail/dashboard/i18n';
import { BlockState } from './BlockState';

interface Props {
  message: string;
  onRetry?: () => void;
}

export const BlockErrorState = ({ message, onRetry }: Props) => {
  const t = useDashboardTFunction();

  return (
    <BlockState>
      <ErrorOutlineRoundedIcon color="error" />
      <Typography variant="body2">{message}</Typography>
      {onRetry && (
        <Button
          size="small"
          variant="text"
          startIcon={<RefreshRoundedIcon />}
          onClick={onRetry}
          sx={{ textTransform: 'none' }}
        >
          {t('dashboard.messages.retry')}
        </Button>
      )}
    </BlockState>
  );
};
